import type { KnowledgeBaseLibraryEntry } from "knowledge-base/_api/knowledge-base-api";

/**
 * The external libraries belonging to other organizations the reader works for.
 *
 * "Not own" rather than "External": the reader's own external library is also external, and it is
 * already one of the two tabs above the contents. What this picks out is the shelf of other
 * people's rules, which is the part nothing outside the knowledge base page linked to.
 */
export function clientLibraries(
  libraries: readonly KnowledgeBaseLibraryEntry[] | undefined
): KnowledgeBaseLibraryEntry[] {
  return (libraries ?? []).filter((entry) => !entry.isOwn && entry.library === "External");
}

/**
 * One named organization's library, if the reader may open it.
 *
 * The list from the server is the authority on reach, so a caller that holds a legal entity id from
 * somewhere else — a work agreement, say — asks here rather than assuming. A link built without
 * this check would appear on every agreement and lead to the reader's own library whenever the
 * server declined, which reads as the wrong articles rather than as a refusal.
 */
export function clientLibraryOf(
  libraries: readonly KnowledgeBaseLibraryEntry[] | undefined,
  ownerLegalEntityId: string | undefined
): KnowledgeBaseLibraryEntry | undefined {
  if (!ownerLegalEntityId) return undefined;

  return clientLibraries(libraries).find(
    (entry) => entry.ownerLegalEntityId === ownerLegalEntityId
  );
}
